"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultKeys = exports.DefaultHandlerKeys = void 0;
exports.DefaultHandlerKeys = {
    strictBlockCollision: true,
    jumpOnAllEdges: false,
    jumpToClearSmallDip: false,
    jumpIntoWater: false,
    maxBlockOffset: 0,
    minimizeFallDmg: false,
    debug: false
};
exports.DefaultKeys = {
    enabled: false,
    cancelOnShift: false
};
